import { pino } from 'pino';
export function buildLogger(options) {
    return pino({
        name: '@coveo/headless',
        level: options?.level || 'warn',
        formatters: {
            log: options?.logFormatter,
        },
    });
}
